export enum AppStage {
    ActionInProgress,
    Error,
    Redirect,
}
